import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { TransportadorService } from "../../servicios/transportador.service";
import { ServicioService } from "../../servicios/servicio.service";
import { HelperService } from "../../servicios/helper.service";
import * as _moment from "moment";
import { Utils } from "../../utils/utils";
import { MatSnackBar } from "@angular/material/snack-bar";

export interface Transportador {
  Id: string;
  Valor: string;
}

@Component({
  selector: "app-asignacion-servicios",
  templateUrl: "./asignacion-servicios.component.html",
  styleUrls: ["./asignacion-servicios.component.css"],
})
export class AsignacionServiciosComponent implements OnInit {
  transportadorGroup: FormGroup;

  filteredTransportadores: Observable<Transportador[]>;
  transportadores: Transportador[] = [];
  asignados: any[] = [];
  sinAsignar: any[] = [];

  constructor(
    private servicioTransportador: TransportadorService,
    private sServicio: ServicioService,
    private formBuilder: FormBuilder,
    private _helper: HelperService,
    public ruta: Utils,
    private snackBar: MatSnackBar
  ) {
    this.transportadorGroup = this.formBuilder.group({
      transportadorCtrl: [""],
    });
    this.filteredTransportadores = this.transportadorGroup
      .get("transportadorCtrl")
      .valueChanges.pipe(
        startWith(""),
        map((transportador) =>
          transportador
            ? this._filteredTransportadores(transportador)
            : this.transportadores.slice()
        )
      );
  }

  ngOnInit() {
    this.servicioTransportador.getTransportador().subscribe((data) => {
      //alert(JSON.stringify(data));
      this.transportadores = data;
    });
    this.ruta.setRuta();
  }

  private _filteredTransportadores(value: any): Transportador[] {
    let filterValue: any;
    if (typeof value === "object") {
      filterValue = value.Valor.toLowerCase();
    } else {
      filterValue = value.toLowerCase();
    }

    return this.transportadores.filter(
      (transportador) =>
        transportador.Valor.toLowerCase().indexOf(filterValue) === 0
    );
  }

  buscarServicios(valor) {
    const transportadorSelected = this.transportadorGroup.controls[
      "transportadorCtrl"
    ].value;
    this.actualizarDatos(transportadorSelected);
  }

  displayFn(project): string {
    console.log(project);
    return project ? project.Valor : project;
  }

  asignarServicio(servicio) {
    //alert(JSON.stringify(servicio));
    let fecha = new Date(servicio.fechaPrestacion);
    let nfecha = _moment(fecha).format("YYYY-MM-DD HH:mm:ss");

    //return;
    const usuarioAsignado = this.transportadorGroup.controls[
      "transportadorCtrl"
    ].value;
    const infoUsuario = JSON.parse(sessionStorage.infoUsuario);
    const params = {
      IdentificadorPA: "SVCASG001",
      TokenTrans: "dfdfdfdf",
      Data: [
        {
          IdServicioEnc: servicio.idServicio,
          IdUsuarioAsignado: usuarioAsignado.Id,
          FechaVisita: nfecha,
          IdUsuario: infoUsuario[0].IdUsuario,
          EstadoAsignacion: 1,
        },
      ],
    };
    this.sServicio.postAsignarServicio(params).subscribe((data) => {
      //alert(JSON.stringify(data));
      if (data[0].Mensaje == "Transaccion Exitosa") {
        const transportadorSelected = this.transportadorGroup.controls[
          "transportadorCtrl"
        ].value;
        this.actualizarDatos(transportadorSelected);
        this.snackBar.open(
          "Informacion Registrada Exitosamente",
          "Asignación Servicios",
          {
            duration: 3000,
          }
        );
      }
    });
  }

  removerServicio(servicio) {
    //alert(JSON.stringify(servicio));
    const usuarioAsignado = this.transportadorGroup.controls[
      "transportadorCtrl"
    ].value;
    const infoUsuario = JSON.parse(sessionStorage.infoUsuario);
    const params = {
      IdentificadorPA: "SVCASG003",
      TokenTrans: "dfdfdfdf",
      Data: [
        {
          IdServicioAsignacion: servicio.idServicio,
        },
      ],
    };
    this.sServicio.postAsignarServicio(params).subscribe((data) => {
      if (data[0].Mensaje == "Transaccion Exitosa") {
        const transportadorSelected = this.transportadorGroup.controls[
          "transportadorCtrl"
        ].value;
        this.actualizarDatos(transportadorSelected);
        this.snackBar.open(
          "Informacion Registrada Exitosamente",
          "Asignación Servicios",
          {
            duration: 3000,
          }
        );
      }
      //alert(JSON.stringify(data));
    });
  }

  actualizarDatos(transportadorSelected) {
    this.asignados = [];
    this.sinAsignar = [];
    this.sServicio
      .getServiciosAsignados(transportadorSelected.Id)
      .subscribe((data) => {
        //this.asignados=data;
        let dataInfo: any;
        const origen = this._helper.where(data, { Descripcion: "ORIGEN" });
        dataInfo = origen;
        dataInfo.forEach((element) => {
          //alert(JSON.stringify(element.NroServicio));
          let item = {
            idServicio: "",
            NroServicio: "",
            DireccionOrigen: "",
            fechaPrestacion: "",
          };
          item.idServicio = element.idServicioEnc;
          item.NroServicio = element.NroServicio;
          item.DireccionOrigen = element.Direccion;
          item.fechaPrestacion = element.fechaPrestacion;
          this.asignados.push(item);
        });

        this.asignados.forEach((element, index) => {
          const destino = this._helper.where(data, {
            Descripcion: "DESTINO",
            NroServicio: element.NroServicio,
          });
          let dataDestino: any;
          dataDestino = destino;
          this.asignados[index].DireccionDestino = dataDestino[0].Direccion;
        });

        console.log("Asignados" + JSON.stringify(this.asignados));
      });

    this.sServicio.getServiciosDisponibles().subscribe((data) => {
      let dataInfo: any;
      const origen = this._helper.where(data, { Descripcion: "ORIGEN" });
      dataInfo = origen;
      dataInfo.forEach((element) => {
        //alert(JSON.stringify(element.NroServicio));
        let item = {
          idServicio: "",
          NroServicio: "",
          DireccionOrigen: "",
          fechaPrestacion: "",
        };
        //alert(element.idServicio);
        item.idServicio = element.idServicioEnc;
        item.NroServicio = element.NroServicio;
        item.DireccionOrigen = element.Direccion;
        item.fechaPrestacion = element.fechaPrestacion;
        this.sinAsignar.push(item);
      });

      this.sinAsignar.forEach((element, index) => {
        const destino = this._helper.where(data, {
          Descripcion: "DESTINO",
          NroServicio: element.NroServicio,
        });
        let dataDestino: any;
        dataDestino = destino;

        this.sinAsignar[index].DireccionDestino = dataDestino[0].Direccion;
        //alert(JSON.stringify(this.asignados));
      });
      console.log("No Asignados" + JSON.stringify(this.sinAsignar));
    });
  }
}
